interface LocationChangeCTAProps {
	countryName: string;
	locationChangeText: string;
	eventHandler: (event: React.MouseEvent | React.KeyboardEvent) => Promise<void>;
	forceHandlerOnKeyUp?: boolean;
}

export const LocationChangeCTA = ({
	countryName,
	locationChangeText,
	eventHandler,
	forceHandlerOnKeyUp = false
}: React.PropsWithChildren<LocationChangeCTAProps>) => {
	return (
		<div className="public-global-splash-location">
			<span className="public-global-splash-country t-label-xs-heavy tc-cool-gray-02">
				{countryName}
			</span>
			<div
				className="public-global-splash-location-cta"
				aria-label={locationChangeText}
				role="button"
				tabIndex={0}
				data-a="true"
				data-a-lbl={countryName}
				data-a-cat="Audience"
				data-a-act="Change Location"
				onClick={eventHandler}
				onKeyDown={forceHandlerOnKeyUp ? undefined : eventHandler}
				onKeyUp={forceHandlerOnKeyUp ? eventHandler : undefined}
				data-qa="audience-link-locationchange"
			>
				{locationChangeText}
			</div>
		</div>
	);
};
